import { SelectLocal } from '../SelectLocal/index'
import React, { useEffect, useState } from 'react'
import { DropdownRoot as Dropdown } from '../common/Dropdown'
import { resetTranslation, translateGoogle } from '../../common_functions'

interface Translation {
  translatedText: string
}

interface GoogleTranslateResponse {
  data: {
    translations: Translation[]
  }
}

export function HeaderLinks() {
  const [showClose, setShowClose] = useState(false)
  const dropdownParaEmpresas = {
    Parceiros: '/parceiros',
    'Construtoras e Incorporadoras': '/construtoras-e-incorporadoras',
    Corretores: '/corretores',
    Imobiliárias: '/imobiliarias'
  }

  const dropdownParaVoce = {
    Contato: '/contato',
    'De Portas Abertas': 'https://deportasabertasglemo.com.br/',
    Vídeocasts: 'https://videocast.glemo.com.br/'
  }

  const dropdownSobreGlemo = {
    'O que é o glemO': '/o-glemo',
    'Dúvidas frequentes': '/duvidas-frequentes',
    'Sala de imprensa': '/sala-de-imprensa'
    // 'Trabalhe Conosco': '/trabalhe-conosco',
  }

  const dropdownSimuladores = {
    'Poder de Compra': '/simuladores',
    'Imóvel Ideal': '/simuladores/imovel-ideal'
  }

  const changeLanguage = (lang: string) => {
    const select = document.querySelector<HTMLSelectElement>('.goog-te-combo')
    if (select) {
      select.value = lang
      const event = new Event('change', { bubbles: true })
      select.dispatchEvent(event)
    }
  }

  useEffect(() => {
    translateGoogle()
    setTimeout(() => {
      setShowClose(true)
    }, 2000);
  }, [])

  return (
    <div className="dropdowns-menu w-full text-xl py-3 text-black-60 flex items-center justify-center gap-16">
      <SelectLocal />
      <Dropdown dropdownDict={dropdownParaEmpresas} dropdownButton="Para empresas" />
      <Dropdown dropdownDict={dropdownParaVoce} dropdownButton="Para você" />
      <Dropdown dropdownDict={dropdownSobreGlemo} dropdownButton="Sobre o glemO" />
      {/* <Dropdown dropdownDict={dropdownSimuladores} dropdownButton="Simuladores" /> */}
      <div className="absolute right-12">
        <div id="google_translate_element"></div>
        {showClose && <button className='text-[14px] absolute -mt-[25px] right-0' onClick={resetTranslation}>⨉</button>}
      </div>
    </div>
  )
}
